import { DefaultState, Filters } from 'store/types';

export const SET_LODGING_TABLE_FILTERS = "SET_LODGING_TABLE_FILTERS";

export type LodgingTableFiltersState = DefaultState & {
  contents: Filters;
  exists: boolean;
};

interface SetLodgingTableFilters {
  type: typeof SET_LODGING_TABLE_FILTERS;
  contents: Filters;
  exists: boolean;
}

export type LodgingTableFiltersActionTypes = SetLodgingTableFilters;
